export const logo = 'https://avatars2.githubusercontent.com/u/54272544?s=200&v=4';
